import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, Movie } from '@bufferapp/ui/Icon';
import {
  Media,
  MediaIconWrapper,
  MediaThumbnailWrapper,
  ReelsTagWrapper,
} from './styles';

const MediaThumbnail = ({ size, media, isReels }) => {
  const isGallery = media.length > 1;
  const firstMedia = media[0];
  const hasMediaThumbnail = firstMedia?.type === 'video' || isGallery;

  return (
    <MediaThumbnailWrapper size={size}>
      <Media
        size={size}
        hasMediaThumbnail={hasMediaThumbnail}
        height="100%"
        width="100%"
        src={firstMedia.thumbnail}
      />
      {firstMedia.type === 'video' && !isGallery && !isReels && (
        <MediaIconWrapper size={size}>
          <Movie color="white" />
        </MediaIconWrapper>
      )}
      {isReels && <ReelsTagWrapper size={size}>Reels</ReelsTagWrapper>}
      {isGallery && (
        <MediaIconWrapper size={size}>
          <Carousel color="white" />
        </MediaIconWrapper>
      )}
    </MediaThumbnailWrapper>
  );
};

MediaThumbnail.propTypes = {
  size: PropTypes.oneOf(['extraSmall', 'small', 'medium', 'large']),
  media: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      thumbnail: PropTypes.string,
    })
  ),
  isReels: PropTypes.bool,
};

MediaThumbnail.defaultProps = {
  size: 'medium',
  media: [],
  isReels: false,
};

export default MediaThumbnail;
